import { Link } from 'react-router-dom'
import { ArticleTag } from '../HomePage/ArticleTag'
import {
  articelsHomePageImages,
  postListNewImages,
} from '../../services/images.service'
import { PostAuthorLine } from './PostAuthorLine'
import { GreyBorderBottom } from '../ui/elements'
import { CommentIcon, HeartIcon } from '../ui/icons/shared'

export function LatestPosts({ posts, authorMap }) {
  // מסננים את הפוסט החדש ביותר - אין קשר ל-commentCount כאן
  const mostRecentPost = posts
    .filter((post) => post.createdAt)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]

  const recentPosts = posts
    .filter((post) => post._id !== mostRecentPost?._id)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 4)

  return (
    <section className="container mx-auto">
      <h2 className="text-xl">חדש באתר</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* צד ימין - הפוסט החדש ביותר */}
        {mostRecentPost && (
          <div key={mostRecentPost._id} className="relative">
            <div className="my-4">
              <p className="text-softText">חדש ומדובר</p>
              <GreyBorderBottom className="w-full" />
            </div>

            <Link to={`/post/${mostRecentPost._id}`}>
              {mostRecentPost.imageUrl && (
                <div
                  className="w-full aspect-[16/9] max-h-[500px] overflow-hidden mb-4"
                  aria-label={`תמונה מתוך הפוסט: ${mostRecentPost.title}`}
                >
                  <img
                    src={mostRecentPost.imageUrl}
                    alt={`תמונה מתוך הפוסט: ${mostRecentPost.title}`}
                    title={mostRecentPost.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                    fetchPriority="high"
                    srcSet={`
        ${mostRecentPost.imageUrl}?w=600 600w,
        ${mostRecentPost.imageUrl}?w=1280 1280w
      `}
                    sizes="(max-width: 768px) 100vw, 1280px"
                  />
                </div>
              )}
            </Link>

            <div className="absolute -translate-y-[90%] right-4">
              <ArticleTag tags={mostRecentPost.tags} />
            </div>

            <div className="flex flex-col gap-2 mt-8">
              <h3 className="text-xl text-white w-[320px]">
                <Link to={`/post/${mostRecentPost._id}`}>
                  {mostRecentPost.title}
                </Link>
              </h3>

              <PostAuthorLine
                userId={mostRecentPost.author?.userId}
                createdAt={mostRecentPost.createdAt}
              />

              <div className="flex items-center gap-6">
                <div className="flex gap-2">
                  <CommentIcon />
                  <span className="text-white">
                    {mostRecentPost.commentCount ?? 0}
                  </span>
                </div>
                <div className="flex gap-2">
                  <HeartIcon />
                  <span className="text-white">
                    {mostRecentPost.likes?.length || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* צד שמאל - 4 פוסטים נוספים */}
        <div className="flex flex-col">
          <div className="my-4">
            <p className="text-softText">עלה לאחרונה</p>
            <GreyBorderBottom className="w-full" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {recentPosts.map((post) => (
              <div key={post._id} className="relative">
                <Link to={`/post/${post._id}`}>
                {post.imageUrl && (
  <div
    className="w-full aspect-[16/9] max-h-[220px] overflow-hidden mb-4"
    aria-label={`תמונה מתוך הפוסט: ${post.title}`}
  >
    <img
      src={post.imageUrl}
      alt={`תמונה מתוך הפוסט: ${post.title}`}
      title={post.title}
      className="w-full h-full object-cover"
      loading="lazy"
      decoding="async"
      srcSet={`
        ${post.imageUrl}?w=600 600w,
        ${post.imageUrl}?w=1280 1280w
      `}
      sizes="(max-width: 768px) 100vw, 768px"
    />
  </div>
)}

                </Link>

                <div className="absolute -translate-y-[90%] right-4">
                  <ArticleTag tags={post.tags} />
                </div>

                <div className="flex flex-col gap-2 mt-8">
                  <h3 className="text-xl text-white w-[320px]">
                    <Link to={`/post/${post._id}`}>{post.title}</Link>
                  </h3>

                  <PostAuthorLine
                    userId={post.author?.userId}
                    createdAt={post.createdAt}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
